import { render, staticRenderFns } from "./ExtraPayments.vue?vue&type=template&id=25b05a86&scoped=true&"
import script from "./ExtraPayments.vue?vue&type=script&lang=ts&"
export * from "./ExtraPayments.vue?vue&type=script&lang=ts&"
import style0 from "./ExtraPayments.vue?vue&type=style&index=0&id=25b05a86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b05a86",
  null
  
)

export default component.exports